module.exports = __webpack_public_path__ + "static/media/Fisherman.ec285eb7.jpg";